export const RESPONSE_CODE_SUCCESS = 200;
export const RESPONSE_CODE_NOT_AUTHORIZED = 401;
export const RESPONSE_CODE_RESOURCE_NOT_FOUND = 404;
export const RESPONSE_CODE_LIMIT_EXCEEDED = 429;
export const RESPONSE_CODE_INAPPROPRIATE_TEXT = 452;
export const RESPONSE_CODE_INAPPROPRIATE_MEDIA = 453;
export const RESPONSE_CODE_RESOURCE_SUSPENDED = 454;
export const RESPONSE_CODE_PROFILE_UNAUTHENTICATED = 551;
export const RESPONSE_CODE_PRIVACY_POLICY_UNACCEPTED = 552;
export const RESPONSE_CODE_PROFILE_DEACTIVATED = 553;
export const RESPONSE_CODE_PROFILE_SUSPENDED = 554;
